import * as j from '@mojotech/json-type-validation';

export interface PublicHolidays {
  year: number;
  month: number;
  day: number;
  name: string;
  information: string;
  timezones: string[];
  postcodes?: string[];
}

export type PublicHolidaysResponse = {
  publicHolidays: PublicHolidays[];
  nextPageUrl: string | null;
};

const PublicHolidayDecoder: j.Decoder<PublicHolidays> = j
  .object({
    year: j.number(),
    month: j.number(),
    day: j.number(),
    name: j.string(),
    information: j.string(),
    timezones: j.array(j.string()),
    postcodes: j.array(j.string()),
  })
  .map((item: any) => ({
    year: item.year,
    month: item.month,
    day: item.day,
    name: item.name,
    information: item.information,
    timezones: item.timezones,
    postcodes: item.postcodes,
  }));

export const PublicHolidaysResponseDecoder: j.Decoder<PublicHolidaysResponse> = j
  .object({
    next_page_url: j.union(j.string(), j.constant(null)),
    public_holidays: j.array(PublicHolidayDecoder),
  })
  .map((item: any) => ({
    nextPageUrl: item.next_page_url,
    publicHolidays: item.public_holidays,
  }));
